/**
 * PolicenkontrolleTabelle - the field-wise Antrag (Soll) vs Police (Ist) compare table (P2 Slice 15).
 */
import { StatusDot, type StatusTone } from '../../components/ui/StatusDot';
import { POLICENKONTROLLE_FELD_STATUS_LABELS, type PolicenkontrolleZeile, type PolicenkontrolleFeldStatus } from '@brokly/shared';

const TONE: Record<PolicenkontrolleFeldStatus, StatusTone> = {
  gleich: 'success',
  abweichend: 'danger',
  unbekannt: 'neutral',
  info: 'info',
};

function cell(v: string | number | null): string {
  if (v === null || v === undefined || v === '') return '-';
  return String(v);
}

export function PolicenkontrolleTabelle({ zeilen }: { zeilen: PolicenkontrolleZeile[] }) {
  return (
    <div className="overflow-x-auto" data-testid="pk-tabelle">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b text-left text-xs text-muted-foreground">
            <th className="py-1 pr-3 font-medium">Feld</th>
            <th className="py-1 pr-3 font-medium">Antrag (Soll)</th>
            <th className="py-1 pr-3 font-medium">Police (Ist)</th>
            <th className="py-1 font-medium">Status</th>
          </tr>
        </thead>
        <tbody>
          {zeilen.map((z) => (
            <tr key={z.feld} className="border-b align-top" {...(z.status === 'abweichend' ? { 'data-abweichend': '' } : {})}>
              <td className="py-2 pr-3">{z.label}</td>
              <td className="py-2 pr-3">{cell(z.soll)}</td>
              <td className="py-2 pr-3">{cell(z.ist)}</td>
              <td className="py-2">
                <StatusDot tone={TONE[z.status]} label={POLICENKONTROLLE_FELD_STATUS_LABELS[z.status]} />
                {(z.toleranz || z.hinweis) && (
                  <div className="mt-0.5 text-xs text-muted-foreground">
                    {[z.toleranz, z.hinweis].filter(Boolean).join(' · ')}
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
